import React from 'react'

const ViolationCard = (props) => {

    let arr = [1,2,3,4,5,6]
    const { violationData } = props;
    console.log("violationData ",violationData)
  return (
        <div className="flex items-center mt-8">
            {
                violationData.map(a => (
                    <div className="p-6 m-1 w-full bg-white rounded-lg border border-gray-200 shadow-md dark:bg-gray-800 dark:border-gray-700">
                    <a href="#">
                    <p class="mb-3 font-normal text-gray-500 dark:text-gray-400">{a.violationName.main}<sub>{a.violationName.sub} Rule</sub></p>
                    
                    <h6  class="mb-2 text-2xl font-semibold tracking-tight text-red-500 dark:text-white">{a.Count}</h6>
                    </a>
                    </div>
                ))
            }
        </div>
    )
}

export default ViolationCard